import styled from "@emotion/styled";

export const WelcomeRoot = styled.div`
    width: 100%;
    flex: 1;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const WelcomeTitle = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 300;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: 0px;
    text-align: center;
    color: #e9ecf5;

    margin-bottom: 96px;

    @media (max-width: 1023px) {
        margin-bottom: 64px;
    }
`;

export const WelcomeNick = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 500;
    font-size: 32px;
    line-height: 125%;
    letter-spacing: 0px;
    text-align: center;
    color: #e9ecf5;

    margin-bottom: 44px;

    @media (max-width: 1023px) {
        white-space: pre-line;
    }
`;

export const WelcomeInput = styled.input`
    width: 320px;
    height: 48px;

    padding: 7.24px 16px;
    border-radius: 8px;

    border: 1px solid #2b2d33;
    background: #23252a;

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #e9ecf5;

    &::placeholder {
        font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        text-align: center;
        color: #9ca3af;
        opacity: 1;
    }

    margin-bottom: 16px;

    &:focus,
    &:focus-visible {
        outline: none;
        box-shadow: none;
        border-color: #2b2d33;
    }
`;

export const WelcomeBtn = styled.button`
    width: 320px;
    height: 48px;

    padding: 7.24px 28.95px;
    border-radius: 8px;
    border: none;

    background: #5e84ed;

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #ffffff;

    margin-bottom: 32px;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const WelcomeHint = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    color: #b7bdcb;

    @media (max-width: 1023px) {
        font-size: 18px;
        white-space: pre-line;
    }
`;
